import React from 'react';
import { CheckIcon, XIcon, LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { comparisonRows } from '../data/comparison';
import { PRICE, PRICE_PLN } from '../data/valueStack';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const assurances = [{
  icon: LockIcon,
  label: 'Bezpieczna płatność'
}, {
  icon: ZapIcon,
  label: 'Natychmiastowy dostęp'
}, {
  icon: ShieldCheckIcon,
  label: '10 dni gwarancji'
}];
export function FinalComparison() {
  return <section aria-labelledby="final-heading" className="bg-forest py-16 sm:py-24" data-id="element-43" data-mp="3eoey0lreqpju">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-44" data-mp="3iofe0au5n8t0">
        <SectionHeading id="final-heading" intro="Zaplanowaliśmy za Ciebie cały semestr i przygotowaliśmy materiały. Ty wchodzisz, patrzysz i uczysz." data-id="element-45" data-mp="3imuh4ekdbdrz">
          Przestań improwizować. <span className="text-gold" data-id="element-46" data-mp="2qvye05o40nhw">Zacznij uczyć z planem.</span>
        </SectionHeading>

        <div className="mx-auto mt-10 grid max-w-4xl gap-4 sm:mt-12 md:grid-cols-2 md:gap-5" data-id="element-47" data-mp="2ux9unlp09ydy">
          <div className="rounded-2xl border border-white/10 bg-forest-deep p-5 sm:p-7" data-id="element-48" data-mp="fxospwevo41o">
            <p className="font-display text-2xl font-extrabold text-copy-light" data-id="element-49" data-mp="axaut76zqahd">Bez Arsenału</p>
            <ul className="mt-4 space-y-3.5" data-id="element-50" data-mp="63y8x4tp4hsb">
              {comparisonRows.map(row => <li key={row.without} className="flex items-start gap-3" data-id="element-51" data-mp="166fg6deknm0">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-52" data-mp="3se26dets8j4v" />
                  <span className="text-sm leading-snug text-copy-light sm:text-base" data-id="element-53" data-mp="3ob5su2j3nd7s">{row.without}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-gold bg-card p-5 sm:p-7" data-id="element-54" data-mp="3edhn6hjyglau">
            <p className="font-display text-2xl font-extrabold text-gold" data-id="element-55" data-mp="3efkmjs6zzqs8">Z Arsenałem</p>
            <ul className="mt-4 space-y-3.5" data-id="element-56" data-mp="1hivafe72gzgk">
              {comparisonRows.map(row => <li key={row.with} className="flex items-start gap-3" data-id="element-57" data-mp="1cmo6fqy8dy19">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-btn" aria-hidden="true" data-id="element-58" data-mp="371bdg0slb7ps" />
                  <span className="text-sm font-medium leading-snug text-white sm:text-base" data-id="element-59" data-mp="3btv0rph2xh7s">{row.with}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 flex max-w-xl flex-col items-center text-center" data-id="element-60" data-mp="3227336txj3xv">
          <p className="text-base text-copy-light" data-id="element-61" data-mp="3ps1erl2iimgj">
            50 ćwiczeń + 5 bonusów + plan na 16 tygodni —{' '}
            <span className="font-bold text-white" data-id="element-62" data-mp="3uqmjnxsplubb">
              {PRICE} ({PRICE_PLN})
            </span>
            , płatność jednorazowa.
          </p>
          <div className="mt-6 w-full" data-id="element-63" data-mp="3kthudp3khiqa">
            <CtaButton target="checkout" fullWidth data-id="element-64" data-mp="3ksgjbkmjww8k">
              Chcę gotowy semestr
            </CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-65" data-mp="24dx1gsy22i7a">
            {assurances.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 text-xs text-copy-light sm:text-sm" data-id="element-66" data-mp="rgg1m8tg9osm">
                <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-67" data-mp="mhvacyw6efgb" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}